import { get } from 'lodash'
import { required, email, hasEmojis } from 'utils/validation'
import { PAYMENT_TYPES } from 'constants/enums'

const validate = values => {
  let errors = {}

  errors.helpers = {
    price: required(get(values, 'helpers.price'))
  }

  if (get(values, 'helpers.price') === PAYMENT_TYPES.online.id) {
    errors.parentEmail =
      required(values.parentEmail) || email(values.parentEmail)

    if (
      get(values, 'parentEmail') &&
      get(values, 'confirmEmail') &&
      get(values, 'parentEmail') !== get(values, 'confirmEmail')
    ) {
      errors = {
        ...errors,
        confirmEmail: {
          text: "Emails don't match",
          intlKey: 'errors.emails_dont_match'
        }
      }
    }
  } else if (get(values, 'helpers.price') === PAYMENT_TYPES.onlineManual.id) {
    errors.enteredTransactionId =
      required(values.enteredTransactionId) ||
      hasEmojis(values.enteredTransactionId)
  }

  return errors
}

export default validate
